export default __webpack_public_path__ + "static/media/primary.3f30c37b34214329800d22b1938f4fe5.svg";